import Vue                    from "vue";
import Router                 from "vue-router";
import Home                   from "./views/Home.vue";
import Home1                  from "./views/Home1.vue";
import Home2                  from "./views/Home2.vue";
import Locale                 from "./views/Locale.vue";
import Page                   from "@/views/Page.vue";
import { storage,subdomain }  from "@/utils";


//USE LAZY LOADING ON THESE COMPONENTS: 
const Product = ()          => import('./views/Product.vue');
const Sitemap = ()          => import('./views/Sitemap.vue');
const CatalogIndex = ()     => import('./views/CatalogIndex.vue');
const Dashboard = ()        => import('./views/Dashboard.vue');
const Catalog = ()          => import('./views/Catalog.vue');
const CatalogItem = ()      => import('./components/catalog/CatalogItem.vue');
const CollectionOfUser = () => import('./components/CollectionOfUser.vue');
const Research = ()         => import('./views/Research.vue');
const Privacy = ()          => import('./views/Privacy.vue');
const Program = ()          => import('./views/Program.vue');

//import Privacy from "@/views/Privacy.vue";
//import Research from "@/views/Research.vue";
//import Product from "@/views/Product.vue";
//import Sitemap from "@/views/Sitemap.vue";
//import CatalogIndex from "@/views/CatalogIndex.vue";
//import Dashboard from "@/views/Dashboard.vue";
//import Catalog from "@/views/Catalog.vue";
//import CatalogItem from "@/components/catalog/CatalogItem.vue";
//import CollectionOfUser from "@/components/CollectionOfUser.vue";
//import Research from "@/views/Research.vue";

Vue.use(Router);

const router = new Router({
  //mode: "history",
  base: process.env.BASE_URL,
  routes: [
    /* /// REDIRECTS FROM OLD SITE <<*/
    {
      path: "/:locale([A-Za-z][A-Za-z]-[A-Za-z][A-Za-z])?",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "",
          //component: Home,
          component: function () {
            return import('@/views/Home2.vue');
          }  ,
          meta: { heroMenu: true }
        },
        {
          path: "user-collection",component: CollectionOfUser
          // meta: { heroMenu: true }
        },
        {
          path: "v2",
          component: Home2
        },

        {
          path: "/demo",component: Home2
          // meta: { heroMenu: true }
        },
        {
          path: "/region",component: Locale
          // meta: { heroMenu: true }
        },
        {
          path: "/privacy",
          component: Privacy
          // meta: { heroMenu: true }
        },
        {
          path: "/program",
          component: Program
          // meta: { heroMenu: true }
        },

        {
          path: "/dashboard",
          component: Dashboard,
          meta: { heroMenu: true }
        },
        {
          path: "product-catalog/:catName",
          //remove below for using seperated pages of products
          component: Catalog          
            ,children: [
            {
              path: ":catId",
              component: CatalogItem
            }
          ]
        },
        {
          path: "product/:catNo",/*This route will replace the component: CatalogItem*/ 
          component: Product /* example: http://localhost:8080/product/V3-10330 */
        },
        {
          path: "sitemap",
          component: Sitemap
        },
        {
          path: "catalog-index",
          component: CatalogIndex
        },
        {
          path: "research-and-development/research-library",
          component: Research
        },
        {
          path: "research-and-development/research-library/:searchterm",
          component: Research
        },
        {
          //http://localhost:8080/loc/it-it  
          //http://localhost:8080/set-region/it-it
          path: "loc/:region",
          component: Locale
        },
        {
          path: "education/learn-online/user-manuals",
          beforeEnter() {
            window.open("https://www.eifu.online/MIS", "_blank");
          }
        },
        {
          path: "events/:event",
          redirect: "events"
        },
        {
          path: ":main",
          component: Page
        },
        {
          path: ":main/:sub",
          component: Page
        },
        {
          path: ":main/:sub/:subitem",
          component: Page
        },
        {
          path: ":main/:sub/:subitem/:inneritem",
          component: Page
        },
        {
          path: ":main/:sub/:subitem/:inneritem/:item",
          component: Page
        }
      ]
    }
  ]
});

//router.beforeEach((to, from, next) => {});
///CHECK THIS PART 
/*
router.beforeEach((to, from, next) => 
{
  
  if ( window.location.href.indexOf("mis-implants") > -1 && window.location.protocol != "https:") 
  {
    location.href = location.href.replace("http://", "https://");
  } 
  else 
  {
    let localeFromStorage = storage.get(`MIS-locale`, localStorage),
      path;
    if (localeFromStorage) {
      if (localeFromStorage !== "en" && !to.params.locale) {
        //Add Locale...
        path = `/${localeFromStorage}${to.fullPath}`;
      } else if (localeFromStorage === "en" && to.params.locale) {
        //Back to default...
        path = to.fullPath.replace(`/${to.params.locale}`, "");
      }
      next(path);
    } else if (to.params.locale) {
      path = to.fullPath.replace(`/${to.params.locale}`, "");
      next(path);
    } else {
      next();
    }
  }  
});
*/


export default router;
